export const DATA_TYPES = [
  {
    dataType: 'Currency',
    description:
      'Accepts a currency amount that the system automatically formats.',
  },
  {
    dataType: 'Date',
    description: 'Allows staff to enter or pick a date from a popup calendar.',
  },
  {
    dataType: 'Email',
    description:
      'Accepts an email address of up to 80 characters, validated to ensure proper format.',
  },
  {
    dataType: 'Number',
    description:
      'Accepts any number, treated as a real number with any leading zeros or spaces removed.',
  },
  {
    dataType: 'Percent',
    description: 'Accepts a percentage number as a decimal.',
  },
  {
    dataType: 'Phone',
    description: 'Accepts any US phone number, validated for format.',
  },
  {
    dataType: 'Picklist',
    description:
      'Allows staff to select a single value from a list that you define.',
  },
  {
    dataType: 'Picklist (multi-select)',
    description:
      'Allows staff to select multiple values from a list that you define.',
  },
  {
    dataType: 'Text',
    description:
      'Accepts any combination of letters, numbers, or symbols up to 255 characters with any leading/trailing spaces removed.',
  },
  {
    dataType: 'Text area',
    description:
      'Accepts up to 255 characters on separate lines with any leading spaces removed.',
  },
  {
    dataType: 'Text area (long)',
    description:
      'Accepts up to 32,768 characters on separate lines with any leading spaces removed.',
  },
  {
    dataType: 'Time',
    description: 'Accepts a time of day.',
  },
  {
    dataType: 'True / False',
    description: 'Allows staff to select true or false.',
  },
  {
    dataType: 'Unique ID',
    description:
      'Accepts up to 255 characters to act as a unique record identifier for an external system.',
  },
  {
    dataType: 'URL',
    description:
      'Accepts any valid website address that opens in a separate browser window when clicked.',
  },
]
